import {autoserializeAs, inheritSerialization} from 'cerialize';
import {RsvpAnswer} from './rsvp-answer';

@inheritSerialization(RsvpAnswer)
export class RsvpOpenAnswer extends RsvpAnswer {
  public static readonly type = 'RsvpOpenAnswer';
  public readonly type = RsvpOpenAnswer.type;

  @autoserializeAs('text')
  public text = '';
}
